export enum SiteQueryReason {
  Clarify = 'CLARIFY',
  Quantity = 'QUANTITY',
}

export enum SiteQueryCaseType {
  ToleranceDeviation = 'TOLERANCE_DEVIATION',
  OffshoreChange = 'OFFSHORE_CHANGE',
  MaterialRepair = 'MATERIAL_REPAIR',
  OtherClarification = 'OTHER_CLARIFICATION',
}

export enum SiteQueryStatus {
  Draft = 'DRAFT',
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS',
  Answered = 'ANSWERED',
}

export interface SiteQueryAttachment {
  id: string;
  fileName: string;
  contentType?: string;
  size: number;
  createdAt: string;
}

export interface SiteQueryReference {
  type: 'TAG' | 'DOCUMENT';
  id: string;
  number: string;
}

export interface WorkOrderSiteQuery {
  id: string;
  workOrderId: string;
  workOrderNumber: string;
  documentType: string;
  sqNumber?: string | null;
  revision: string;
  taskId: string;
  title: string;
  deliveryId: string;
  site?: string | null;
  discipline?: string | null;
  reason: SiteQueryReason;
  caseType: SiteQueryCaseType;
  quantityChange: boolean;
  scheduleImpact: boolean;
  materialNeed: boolean;
  description: string;
  suggestedSolution: string;
  references?: string | null;
  selectedReferences: SiteQueryReference[];
  initiatedBy: string;
  company?: string | null;
  queryDate?: string | null;
  siteLeader?: string | null;
  integrationManager?: string | null;
  status: SiteQueryStatus;
  createdAt: string;
  attachments: SiteQueryAttachment[];
}

export interface CreateWorkOrderSiteQueryRequest {
  revision: string;
  taskId?: string;
  title: string;
  deliveryId: string;
  site?: string;
  discipline?: string;
  reason: SiteQueryReason;
  caseType: SiteQueryCaseType;
  quantityChange: boolean;
  scheduleImpact: boolean;
  materialNeed: boolean;
  description: string;
  suggestedSolution: string;
  references?: string;
  selectedReferences?: SiteQueryReference[];
  initiatedBy: string;
  company?: string;
  queryDate?: string;
  siteLeader?: string;
  integrationManager?: string;
}
